<template>
    <div :class="[{ 'no-interaction': readonly }, 'dynamic-form']">
        <div
            v-for="(row, index) in inputRows"
            :key="index"
            :class="[
                {
                    'border-bottom mb-4': index !== Object.keys(inputRows).length - 1,
                    'row align-items-center': isHorizontal,
                },
                'dynamic-form-row',
            ]"
        >
            <div
                v-for="field in fields"
                v-show="field.type !== 'input-hidden'"
                :key="`${index}-${field.name}`"
                :class="[
                    isHorizontal ? colClass : 'row',
                ]"
            >
                <ui-dynamic-form-field
                    :field="field"
                    :fields="fields"
                    :index="index"
                    :is-horizontal="isHorizontal"
                    :name="name"
                    :readonly="row['readonly'] || readonly"
                    :row="row"
                />
            </div>

            <button
                v-if="index > (minRows - 1) && !(row['readonly'] || readonly)"
                @click="removeRow(index)"
                type="button"
                class="btn btn-danger btn-symbol ml-auto mb-4 dynamic-form-row-delete"
                aria-label="Remove"
            >
                <ui-icon icon="delete" />
            </button>
        </div>

        <button
            v-if="!readonly"
            @click="addEmptyRow"
            type="button"
            class="btn btn-primary btn-icon ml-auto"
        >
            <ui-icon icon="add" />
            {{ $t('general.add') }}
        </button>
    </div>
</template>

<script>
    import UiIcon from '../../ui/icon.vue';
    import UiDynamicFormField from './field.vue';

    export default {
        name: 'DynamicForm',
        components: {
            UiIcon,
            UiDynamicFormField,
        },
        props: {
            addText: {
                required: false,
                type: String,
                default: 'Add',
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            fields: {
                required: true,
                type: Array,
            },
            name: {
                required: true,
                type: String,
            },
            layout: {
                type: String,
                default: 'vertical',
            },
            colClass: {
                type: String,
                default: 'col-3',
            },
            rows: {
                type: Array,
                default: () => [],
            },
            minRows: {
                type: Number,
                default: 1,
            },
        },
        data() {
            return {
                inputRows: JSON.parse(JSON.stringify(this.rows)),
            };
        },
        computed: {
            isHorizontal() {
                return this.layout === 'horizontal';
            },
        },
        methods: {
            addEmptyRow() {
                this.inputRows.push(
                    this.fields.reduce((acc, field) => {
                        acc[field.name] = field.value || '';
                        return acc;
                    }, {}),
                );
            },

            removeRow(index) {
                this.inputRows.splice(index, 1);
            },
        },
        mounted() {
            if (!this.inputRows.length && this.minRows > 0) this.addEmptyRow();
        },
    };
</script>

<style lang="scss" scoped>
    .dynamic-form {
        &-row {
            position: relative;

            &:not(:first-child) {
                padding-right: 52px;
            }

            &-delete {
                position: absolute;
                top: 2px;
                right: 0;
            }
        }
    }
</style>
